import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { DecoratorService } from './decorators/decorator.service';
import { DEFAULT_PERSONAL_DATA_PROTECTION_PROVIDERS } from './defaults';

export * from './defaults';

@NgModule({
    imports: [CommonModule],
    providers: [DecoratorService, CookieService, ...DEFAULT_PERSONAL_DATA_PROTECTION_PROVIDERS],
})
export class PersonalDataProtectionModule {
    // We need an instance of DecoratorFactory here to connect the PersonalDataProtectionService with DecoratorFactory.
    constructor() {
        // Inject DecoratorService to ensure it's initialized before any components with @Protect decorators are created
        inject(DecoratorService);
    }
}
